import { Model, fk, many, attr } from "redux-orm";

class ChallengeUserLessonModel extends Model {
  static reducer(action, ChallengeUserLessonModel, session) {
    switch (action.type) {
      case "UPSERT_challenge-user-lesson":
        action.payload.forEach((payload) => {
          const dbData = ChallengeUserLessonModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ChallengeUserLessonModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ChallengeUserLessonModel.modelName = "ChallengeUserLessonModel";

ChallengeUserLessonModel.fields = {
  id: attr(),
};

export default ChallengeUserLessonModel;